module.exports = __webpack_public_path__ + "img/perforaciones2_4-3_3072.9838c61e.jpg";